/* eslint-disable max-params */
import { Injector, runInInjectionContext } from '@angular/core';
import { SubmittedDocument } from '@data-access/documents';
import { TasksDetailFacadeService, TasksFacadeService } from '../facade';
import { HandleSideBarService } from '@data-access/shared';
import {
  TaskDetailComponent,
  TaskListComponent,
} from '@submissions/next/sidebar';
import { TaskInstance } from '../types/task.type';
import environment from '@environments/environment';
import { ComponentType } from '@angular/cdk/overlay';

/*
 * In document list/detail view, opens sidebar with either single task detail or list of tasks for the selected document.
 */
export function navigateToTaskInfo(
  injector: Injector,
  document: SubmittedDocument,
  taskCount: number,
  submissionId: string,
  tasks: TaskInstance[],
) {
  return runInInjectionContext(injector, () => {
    const tasksDetailFacadeService = injector.get(TasksDetailFacadeService);
    const tasksFacadeService = injector.get(TasksFacadeService);

    // if task enabled flag is false, do nothing
    if (!environment.enabledTask) {
      return;
    }
    if (taskCount === 1) {
      const taskInstanceId = document.document_tasks[0].task_instance_id;
      tasksDetailFacadeService.loadTaskDetail(submissionId, taskInstanceId);
      openSidebarComponent(injector, TaskDetailComponent);
    } else {
      const documentTasksIds = document.document_tasks.map(
        (task) => task.task_instance_id,
      );

      const filteredTasks = tasks.filter((task) =>
        documentTasksIds.includes(task.id),
      );

      tasksFacadeService.updateTaskList(filteredTasks);

      openSidebarComponent(injector, TaskListComponent);
    }
  });
}

/*
 * Opens the sidebar with the specified component if it's not already open.
 */
export function openSidebarComponent(
  injector: Injector,
  component: ComponentType<unknown>,
) {
  return runInInjectionContext(injector, () => {
    const handleSideBarService = injector.get(HandleSideBarService);
    handleSideBarService.setToggleSideBarOpen(true);
    if (
      handleSideBarService.$currentComponentRef()?.componentType !== component
    ) {
      handleSideBarService.setSideBarComponent(component);
    }
  });
}

/*
 * Used to check if a document in the list has any pending (new_task) tasks.
 */
export function hasPendingTask(
  document: SubmittedDocument,
  tasks: TaskInstance[],
): boolean {
  const documentTasksIds = document.document_tasks.map(
    (task) => task.task_instance_id,
  );

  const relatedTasks = tasks.filter((task) =>
    documentTasksIds.includes(task.id),
  );

  return relatedTasks.some((task) => ['new_task'].includes(task.status));
}
